import { createLike, deleteLikeByFqdnAndEntityId } from '@wix/ambassador-blog-v1-like/http';
import { type CommonThunkAction } from '../../../../types/common-thunk-action.type';
import { INCREMENT_POST_LIKE_COUNT_FAILURE } from './post-likes-actions-types';
import { getPostLikes } from './post-likes-selectors';

const incrementPostLikeCountFailure = createLikeAction({
  type: INCREMENT_POST_LIKE_COUNT_FAILURE,
  isLikeInProgress: false,
});

export const incrementPostLikeCount =
  (postId: string, isLiked: boolean): CommonThunkAction<unknown> =>
  (dispatch, getState, { request, httpClient, errorHandler }) => {
    const state = getState();
    const current = getPostLikes(state, postId);
    const { withErrorHandler, getResolvedError } = errorHandler;

    const fqdn = 'wix.blog.v3.post';

    if (state.tpaSettings.settings?.useBlogLikeService) {
      const promise = isLiked
        ? withErrorHandler(
            () =>
              httpClient.request(
                deleteLikeByFqdnAndEntityId({
                  entityId: postId,
                  fqdn,
                }),
              ),
            { errorCodesMap: {} },
          )
        : withErrorHandler(
            () =>
              httpClient.request(
                createLike({
                  like: { entityId: postId, fqdn },
                }),
              ),
            { errorCodesMap: {} },
          );

      return promise.catch((error) => {
        getResolvedError(error);
        dispatch(incrementPostLikeCountFailure(postId, current));
      });
    } else {
      const url = `/v2/posts/${postId}/like`;
      const promise = isLiked ? request.delete(url) : request.post(url, {});

      return promise.catch(() => dispatch(incrementPostLikeCountFailure(postId, current)));
    }
  };

type CreateLikeActionParams = {
  type: string;
  isLikeInProgress: boolean;
};

type LikeActionPayload = {
  likeCount?: number;
  liked?: boolean;
};

function createLikeAction({ type, isLikeInProgress }: CreateLikeActionParams) {
  return (postId: string, { likeCount, liked }: LikeActionPayload = {}) => ({
    type,
    payload: { id: postId, likeCount, liked, isLikeInProgress },
  });
}
